import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../DropdownList/index.js';
import { DropdownTrigger as DropdownTriggerMemo } from './DropdownTrigger.js';
import { DropdownListMigrationAdapter } from '../DropdownList/DropdownList.js';

var getTriggerProps = function getTriggerProps(props) {
  var label = props.label,
    value = props.value,
    placeholder = props.placeholder,
    helperText = props.helperText,
    state = props.state,
    intent = props.intent,
    leadingAsset = props.leadingAsset,
    dataElementName = props['data-element-name'],
    ariaLabel = props['aria-label'],
    ariaLabelledBy = props['aria-labelledby'];
  return {
    label: label,
    value: value,
    placeholder: placeholder,
    helperText: helperText,
    state: state,
    intent: intent,
    leadingAsset: leadingAsset,
    'data-element-name': dataElementName,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy
  };
};
var getDropdownListProps = function getDropdownListProps(_ref) {
  var type = _ref.type,
    items = _ref.items,
    visible = _ref.visible,
    state = _ref.state,
    label = _ref.label,
    onVisibilityChange = _ref.onVisibilityChange,
    onChange = _ref.onChange,
    menuCloseButton = _ref.menuCloseButton,
    menuZIndex = _ref.menuZIndex,
    menuVariant = _ref.menuVariant,
    portalWrapperComponent = _ref.portalWrapperComponent,
    search = _ref.search,
    onSearchChange = _ref.onSearchChange,
    searchPlaceholderText = _ref.searchPlaceholderText,
    searchClearLabelText = _ref.searchClearLabelText,
    bottomSheetTitle = _ref.bottomSheetTitle,
    popover = _ref.popover;
  return {
    type: type,
    items: items,
    visible: visible,
    state: state,
    onVisibilityChange: onVisibilityChange,
    onChange: onChange,
    portalWrapperComponent: portalWrapperComponent,
    title: bottomSheetTitle || label || '',
    closeButton: menuCloseButton,
    zIndex: menuZIndex,
    variant: menuVariant,
    search: search,
    onSearchChange: onSearchChange,
    searchPlaceholderText: searchPlaceholderText,
    searchClearLabelText: searchClearLabelText,
    popover: popover
  };
};
var Dropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DropdownListMigrationAdapter, getDropdownListProps(props), /*#__PURE__*/React.createElement(DropdownTriggerMemo, _extends({
    ref: ref
  }, getTriggerProps(props))));
});
Dropdown.displayName = 'Dropdown';

export { Dropdown, DropdownTriggerMemo as DropdownTrigger };
//# sourceMappingURL=Dropdown.js.map
